<template>
  <div class="index">
    <div class="container" id="container">
      <MyMask ref="change"></MyMask>
      <div v-if="container == 'Industry'">
        <keep-alive>
          <Industry></Industry>
        </keep-alive>
      </div>
      <div v-if="container == 'Competitive'">
        <keep-alive>
          <Competitive></Competitive>
        </keep-alive>
      </div>
      <div v-if="container == 'Consumer'">
        <keep-alive>
          <h1 style="text-align: center; widtht: 100%; text-align: center">
            Coming Soon!
          </h1>
          <Consumer></Consumer>
        </keep-alive>
      </div>
    </div>
    <div class="foot">
      <van-tabbar
        v-model="active"
        fixed
        z-index="99"
        active-color="rgb(188,154,109)"
      >
        <van-tabbar-item @click="change1">
          <template #icon="props">
            <img :src="props.active ? icon.active : icon.inactive" />
          </template>
          <span>行业雷达</span>
        </van-tabbar-item>
        <van-tabbar-item @click="change2">
          <template #icon="props">
            <img :src="props.active ? icon.active2 : icon.inactive2" />
          </template>
          <span>品类雷达</span>
        </van-tabbar-item>
        <van-tabbar-item @click="change3">
          <!-- <van-tabbar-item > -->
          <template #icon="props">
            <img :src="props.active ? icon.active1 : icon.inactive1" />
          </template>
          <span>竞争雷达</span>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>
<script>
import MyMask from "@/components/public/mask";
import qs from "qs";

import Industry from "@/components/ButFo_Radar/Industry_Radar";
import Competitive from "@/components/ButFo_Radar/Competitive_Radar";
import Consumer from "@/components/ButFo_Radar/Consumer_Radar";
import IndustryPngAct from "../../assets/jpg/Industry-active.png";
import CustomerPngAct from "../../assets/jpg/customer-active.png";
import CompetitorPngAct from "../../assets/jpg/competitor-active.png";
import CompetitorPng from "../../assets/jpg/competitor.png";
import CustomerPng from "../../assets/jpg/customer.png";
import IndustryPng from "../../assets/jpg/Industry.png";

export default {
  data() {
    return {
      active: 0,
      container: "Industry",
      icon: {
        active: IndustryPngAct,
        inactive: IndustryPng,
        active1: CustomerPngAct,
        inactive1: CustomerPng,
        active2: CompetitorPngAct,
        inactive2: CompetitorPng,
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    var time = new Date();
    var y = time.getFullYear();
    var m = (time.getMonth() + 1).toString().padStart(2, "0");
    var d = time.getDate().toString().padStart(2, "0");
    var h = time.getHours().toString().padStart(2, "0");
    var mm = time.getMinutes().toString().padStart(2, "0");
    var s = time.getSeconds().toString().padStart(2, "0");
    var EndTime = `${y}-${m}-${d} ${h}:${mm}:${s}`;
    const sendEndObj = {
      startDate: "",
      endDate: EndTime,
      wwid: JSON.parse(sessionStorage.getItem("userInfo")).wwid,
      name: JSON.parse(sessionStorage.getItem("userInfo")).name,
      menu: "Industry Radar",
    };
    this.$addr.post("Log/insert", qs.stringify(sendEndObj)).then((res) => {
      next();
    });
  },
  components: {
    Industry,
    Competitive,
    Consumer,
    MyMask,
  },
  created() {
     this.sendTime('行业雷达');
    sessionStorage.setItem("long", "");
    sessionStorage.setItem("radar", this.container);
  },
  methods: {
    sendTime(menu) {
      var time = new Date();
      var y = time.getFullYear();
      var m = (time.getMonth() + 1).toString().padStart(2, "0");
      var d = time.getDate().toString().padStart(2, "0");
      var h = time.getHours().toString().padStart(2, "0");
      var mm = time.getMinutes().toString().padStart(2, "0");
      var s = time.getSeconds().toString().padStart(2, "0");
      var EndTime = `${y}-${m}-${d} ${h}:${mm}:${s}`;
      const sendEnd = {
        startDate: EndTime,
        endDate: "",
        wwid: JSON.parse(sessionStorage.getItem("userInfo")).wwid,
        name: JSON.parse(sessionStorage.getItem("userInfo")).name,
        menu: "Industry Radar",
        operationModule: menu,
      };
      this.$addr.post("Log/insert", qs.stringify(sendEnd)).then((res) => {});
    },
    change1() {
      this.container = "Industry";
      this.sendTime('行业雷达');
      sessionStorage.setItem("radar", this.container);
       this.$refs.change.loadFun();
    },
    change2() {
      this.container = "Competitive";
       this.sendTime('品类雷达');
      sessionStorage.setItem("radar", this.container);
       this.$refs.change.loadFun();
    },
    change3() {
      this.container = "Consumer";
      this.sendTime('竞争雷达');
      sessionStorage.setItem("radar", this.container);
       this.$refs.change.loadFun();
    },
  },
};
</script>
<style scoped>
.index {
  background-color: rgb(246, 246, 255);
  height: 100%;
}
.container {
  margin-bottom: 50px;
  overflow-x: hidden;
}
h1 {
  position: absolute;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ButFo_Radar/RadarIndex.vue